import { CompanyLogo, HeaderLogo } from "../../../styles/component/style";
import { Images } from "../../../assets/images";
import {
  LogoContainer,
  LinksContainer,
  ProfileImage,
  LogoutText,
  BigScreen,
  SmallScreenMenu,
  SmallScreen,
  Row,
  H2,
  ImageContainer,
  LogoutIcon,
} from "./Styles";
import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import COLORS from "../../../assets/Colors";
import _ from "lodash";
import { navigate, useLocation } from "@reach/router";
import labels from "../../../helpers/labels.json";
import useAlert from "../../../hooks/useAlert";
import { scroller } from "react-scroll";
import { TranslaterContext } from "../../../providers/TranslaterProvider";
import DropDownMenu from "../../common/DropDownMenu";
import TemporaryDrawer from "./Drawer";
import useViewer from "../../../hooks/useViewer";
import AuthService from "../../../services/AuthService";
import moment from "moment";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../helpers/functions";

const EXCLUDE_URL = ["create-profile"];

const useStyles = makeStyles((theme) => ({
  // appBar: {
  //   zIndex: theme.zIndex.drawer + 1,
  //   background: COLORS.PRIMARY_WHITE,
  //   height: 74,
  //   display: "flex",
  //   flexDirection: "row",
  //   alignItems: "center",
  //   borderBottom: "1px solid #e1e3ee",
  // },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    background: COLORS.PRIMARY_WHITE,
    height: 74,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    borderBottom: "1px solid #e1e3ee",

    "@media (max-width:1239px)": {
      height: "auto",
      minHeight: 74,
      alignItems: "stretch",
    },
},
  // appSpacedBar: {
  //   zIndex: theme.zIndex.drawer + 1,
  //   background: COLORS.PRIMARY_WHITE,
  //   height: 74,
  //   display: "flex",
  //   flexDirection: "row",
  //   alignItems: "center",
  //   boxShadow: "none",
  //   borderBottom: "1px solid #e1e3ee",
  //   marginTop: 40,
  // },
  appSpacedBar: {
    zIndex: theme.zIndex.drawer + 1,
    background: COLORS.PRIMARY_WHITE,
    height: 74,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    boxShadow: "none",
    borderBottom: "1px solid #e1e3ee",
    marginTop: 40,

    "@media (max-width:1239px)": {
      height: "auto",
      minHeight: 74,
      alignItems: "stretch",
    },
  },
  // toolbar: {
  //   display: "flex",
  //   justifyContent: "space-between",
  //   alignItems: "center",
  //   width: "100%",
  // },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",

    "@media (max-width:1239px)": {
      flexWrap: "wrap",
      alignContent: "flex-start",
      alignItems: "center",
    },
  },
}));

// export default function StyledAppBar({
export default React.forwardRef(function StyledAppBar({
  NavPages,
  hideLinks,
  LandingPage,
  ArbitPages,
  cartCount,
  setShowDrawer,
  stats,
  hideIcon,
  password,
  showDrawer,
}, ref) {
  const { userObject, globalState, setGlobalState, setUserObject } =
    useViewer();
  const { showAlert, hideAlert } = useAlert();
  const { translaterOpen } = useContext(TranslaterContext);
  const location = useLocation();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  async function viewerLogout(viewerId, role) {
    try {
      const payload = {
        logoutTime: moment(new Date()).format("HH:mm"),
        role: role,
      };
      const eventId = userObject?.eventId;
      const response = await AuthService.viewerLogout(viewerId, payload);
      if (response?.status) {
        enqueueSnackbar("Logout successfully", {
          variant: "success",
        });
        localStorage.removeItem("auth_token");
        localStorage.removeItem("role");
        localStorage.removeItem("pollArray");
        localStorage.removeItem("dsnl_cookies_enabled");
        navigate(`/events/gallery?eventId=${eventId}`);
        setGlobalState({ customTab: [] });
        setUserObject({});
        // setToken("logged_out");
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      hideAlert();
    }
  }

  const handleLogout = () => {
    showAlert({
      heading: "Logout?",
      desc: "Are you sure you want to logout?",
      primaryBtnText: "Logout",
      secondaryBtnText: "Cancel",
      clickSecondarybtn: () => hideAlert(),
      clickPrimaryBtn: () => {
        viewerLogout(userObject?.viewerId, "eventViewer");
      },
      isOpen: true,
      onDialogClose: () => hideAlert(),
    });
  };

  return (
    <AppBar
      position="fixed"
      ref={ref}
      style={{
        boxShadow: "5px 5px 8px #00000011",
        backgroundColor: globalState?.theme?.themeHeader?.bannerBackgroundColor
          ? globalState?.theme?.themeHeader?.bannerBackgroundColor
          : COLORS.PRIMARY_WHITE,
      }}
      className={translaterOpen ? classes.appSpacedBar : classes.appBar}
    >
      <Toolbar className={classes.toolbar}>
        {password === true ? (
          <>
            <LogoContainer
              style={{
                justifyContent:
                  globalState?.theme?.themeHeader?.logoPlacement === "right"
                    ? "flex-start"
                    : "flex-end",
              }}
            >
              {globalState?.theme?.themeHeader?.logoImage ? (
                <HeaderLogo
                  src={
                    globalState?.theme?.themeHeader?.logoImage
                      ? globalState?.theme?.themeHeader?.logoImage
                      : Images.companyLogo
                  }
                  width={globalState?.theme?.themeHeader?.logoWidth}
                  height={globalState?.theme?.themeHeader?.logoHeight}
                />
              ) : null}
            </LogoContainer>
            {/* <ImageContainer> */}
            <ImageContainer className="mobileEventInfo">
              {globalState?.theme?.themeHeader?.eventTitleImage ? (
                <CompanyLogo
                  src={globalState?.theme?.themeHeader?.eventTitleImage}
                />
              ) : (
                <H2
                  style={{
                    color: globalState?.theme?.themeHeader?.eventTitleColor,
                    textShadow: `2px 2px 4px ${globalState?.theme?.themeHeader?.eventTitleShadowColor}`,
                  }}
                >
                  {`${globalState?.eventTitle ?? ""} Hi`}
                </H2>
              )}
            </ImageContainer>
          </>
        ) : (
          <>
            <LogoContainer
              justifyContent={globalState?.theme?.themeHeader?.logoPlacement}
              style={{
                justifyContent:
                  globalState?.theme?.themeHeader?.logoPlacement === "right"
                    ? "flex-end"
                    : "flex-start",
              }}
            >
              {globalState?.theme?.themeHeader?.logoImage ? (
                <HeaderLogo
                  onClick={() =>
                    LandingPage
                      ? scroller.scrollTo("hero", {
                          duration: 500,
                          offset: -70,
                          smooth: true,
                        })
                      : _.isEmpty(userObject)
                      ? ""
                      : navigate("/gallery-viewer-live")
                  }
                  width={globalState?.theme?.themeHeader?.logoWidth}
                  height={globalState?.theme?.themeHeader?.logoHeight}
                  src={
                    globalState?.theme?.themeHeader?.logoImage
                      ? globalState?.theme?.themeHeader?.logoImage
                      : Images.companyLogo
                  }
                />
              ) : null}
            </LogoContainer>
              {/* <ImageContainer> */}
            <ImageContainer className="mobileEventInfo">
              {globalState?.theme?.themeHeader?.eventTitleImage ? (
                <CompanyLogo
                  src={globalState?.theme?.themeHeader?.eventTitleImage}
                />
              ) : (
                // <H2
                //   style={{
                //     color: globalState?.theme?.themeHeader?.eventTitleColor,
                //     textShadow: `2px 2px 4px ${globalState?.theme?.themeHeader?.eventTitleShadowColor}`,
                //   }}
                // >
                //       {/* {globalState?.eventTitle} */}
                //        {`${globalState?.eventTitle ?? ""} Hi`}
                    // </H2>
                    // <H2
                    //   style={{
                    //     color: globalState?.theme?.themeHeader?.eventTitleColor,
                    //     textShadow: `2px 2px 4px ${globalState?.theme?.themeHeader?.eventTitleShadowColor}`,
                    //   }}
                    // >
                    //   {globalState?.eventTitle?.split(/(\d+(?:st|nd|rd|th))/gi).map((part, index) => {
                    //     const match = part.match(/^(\d+)(st|nd|rd|th)$/i);

                    //     if (match) {
                    //       return (
                    //         <span key={index}>
                    //           {match[1]}
                    //           <sup style={{ fontSize: "0.9em", verticalAlign: "super" }}>
                    //             {match[2]}
                    //           </sup>
                    //         </span>
                    //       );
                    //     }

                    //     return <span key={index}>{part}</span>;
                    //   })}
                    // </H2>
                    // <H2
                    //   style={{
                    //     color: globalState?.theme?.themeHeader?.eventTitleColor,
                    //     textShadow: `2px 2px 4px ${globalState?.theme?.themeHeader?.eventTitleShadowColor}`,
                    //     textAlign: "center",
                    //   }}
                    // >
                    //   {/* Event Title */}
                    //   <div>
                    //     {globalState?.eventTitle?.split(/(\d+(?:st|nd|rd|th))/gi).map((part, index) => {
                    //       const match = part.match(/^(\d+)(st|nd|rd|th)$/i);

                    //       if (match) {
                    //         return (
                    //           <span key={index}>
                    //             {match[1]}
                    //             <sup style={{ fontSize: "0.5em", verticalAlign: "super" }}>
                    //               {match[2]}
                    //             </sup>
                    //           </span>
                    //         );
                    //       }

                    //       return <span key={index}>{part}</span>;
                    //     })}
                    //   </div>

                    //   {/* Event Date & Time */}
                    //   <div style={{ marginTop: "10px" }}>
                    //     {globalState?.eventDate ?? globalState?.general?.eventDate}
                    //     {" | "}
                    //     {globalState?.eventTime ?? globalState?.general?.eventTime}
                    //     {" (IST)"}
                    //   </div>
                    // </H2>
                    <H2
                      style={{
                        color: globalState?.theme?.themeHeader?.eventTitleColor,
                        textShadow: `2px 2px 4px ${globalState?.theme?.themeHeader?.eventTitleShadowColor}`,
                        textAlign: "center",
                      }}
                    >
                      {/* Event Title */}
                      <div style={{ fontSize: "1.2em", fontWeight: "bold" }}>
                        {globalState?.eventTitle
                          ?.split(/(\d+(?:st|nd|rd|th))/gi)
                          .map((part, index) => {
                            const match = part.match(/^(\d+)(st|nd|rd|th)$/i);

                            if (match) {
                              return (
                                <span key={index}>
                                  {match[1]}
                                  <sup
                                    style={{
                                      fontSize: "0.55em",
                                      verticalAlign: "super",
                                      lineHeight: 0,
                                    }}
                                  >
                                    {match[2]}
                                  </sup>
                                </span>
                              );
                            }

                            return <span key={index}>{part}</span>;
                          })}
                      </div>

                      {/* Event Date & Time */}
                      <div
                        style={{
                          fontSize: "0.95em",
                          marginTop: "12px",
                          fontWeight: "normal",
                          lineHeight: 1.2,
                        }}
                      >
                        {(() => {
                          const date = globalState?.eventDate ?? globalState?.general?.eventDate;
                          const time = globalState?.eventTime ?? globalState?.general?.eventTime;

                          let formattedDate = date;
                          let formattedTime = time;

                          // DD/MM/YYYY → Month DD, YYYY
                          if (date) {
                            const [day, month, year] = date.split("/");

                            const months = [
                              "January",
                              "February",
                              "March",
                              "April",
                              "May",
                              "June",
                              "July",
                              "August",
                              "September",
                              "October",
                              "November",
                              "December",
                            ];

                            formattedDate = `${months[Number(month) - 1]} ${day}, ${year}`;
                          }

                          // 24-hour HH:mm → 12-hour H.mm am/pm
                          if (time) {
                            const [hours, minutes] = time.split(":");
                            let hour = Number(hours);
                            const ampm = hour >= 12 ? "pm" : "am";

                            hour = hour % 12 || 12;

                            formattedTime = `${hour}.${minutes} ${ampm}`;
                          }

                          return `${formattedDate} | ${formattedTime} (IST)`;
                        })()}
                      </div>
                    </H2>

              )}
            </ImageContainer>
          </>
        )}

        <BigScreen>
          {hideLinks ? null : (
            <LinksContainer>
              {_.isEmpty(userObject) ||
              EXCLUDE_URL.some((path) => location?.pathname?.includes(path)) ? (
                <>{NavPages ? <></> : <></>}</>
              ) : (
                <>
                  <H2>
                    <DropDownMenu
                      title="Tabs"
                      options={[
                        {
                          name: "Sign Out",
                          props: {
                            onClick: () => handleLogout(),
                          },
                        },
                      ]}
                    />
                  </H2>
                  {globalState?.general?.eventTemplate === "AGM" &&
                    globalState?.theme?.themeNavigationBar?.navBarTreatment ===
                      "alwaysVisible" &&
                    showDrawer && (
                      <Row onClick={handleLogout}>
                        <LogoutIcon
                          src={require("../../../assets/images/logout.svg")}
                        />
                        <LogoutText>{"Sign Out"}</LogoutText>
                      </Row>
                    )}
                </>
              )}
            </LinksContainer>
          )}
        </BigScreen>

        <SmallScreenMenu>
          {_.isEmpty(userObject) ? <> </> : null}
        </SmallScreenMenu>
        <SmallScreenMenu>
          {!_.isEmpty(userObject) ? (
            <>
              <TemporaryDrawer
                menuItems={[
                  {
                    name: "Sign Out",
                    props: {
                      onClick: () => handleLogout(),
                    },
                  },
                ]}
              />
            </>
          ) : (
            <SmallScreen>
              <Row>
                <LogoutText onClick={handleLogout}>
                  {labels["appbar.logout"]}
                </LogoutText>
                {password === true ? (
                  <ProfileImage
                    src={
                      userObject.avatarUrl
                        ? userObject.avatarUrl
                        : require("../../../assets/images/userPlaceholder.svg")
                    }
                    onClick={() => navigate("/gallery-viewer-live")}
                  />
                ) : null}
              </Row>
            </SmallScreen>
          )}
        </SmallScreenMenu>
      </Toolbar>
    </AppBar>
  );
});
